<template>
  <v-app>
    <main>
      <NavBar v-if="notWelcome && profile"></NavBar>
      <router-view />
    </main>
  </v-app>
</template>

<script>
import NavBar from "./components/NavBar";
export default {
  computed: {
    notWelcome() {
      if (this.$route.path == "/welcome") {
        return false;
      } else {
        return true;
      }
    }
  },
  components: {
    NavBar
  },
  created() {
    this.$register()
  },
  watch: {
    
  }
};
</script>

<style>
  html {
    overscroll-behavior: none;
  }
  .v-toolbar__content {
    padding-right: 0px;
  }
</style>